import { render } from "./TimeSince.vue?vue&type=template&id=eca0335e"
import script from "./TimeSince.vue?vue&type=script&lang=js"
export * from "./TimeSince.vue?vue&type=script&lang=js"

import "./TimeSince.vue?vue&type=style&index=0&id=eca0335e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__